export default {
  'form': {
    'breadcrumb': {
      'home': 'Home',
      'formPage': 'Form',
      'basicForm': 'Basic Form',
      'formLayout': 'Form Layout',
      'advancedForm': 'Advanced Form',
      'dynamicForm': 'Dynamic Form'
    },
    'basicForm':{
      'title': 'Basic Form',
      'description': 'The form page is used to collect or verify user information. Basic forms can be used to collect, verify, and submit data.'
    },
    'formLayout':{
      'title': 'Form Layout',
      'description': 'The form layout page displays various forms, including horizontal, vertical, pop-up, and multi-column layouts.',
      'horizontalForm': 'Horizontal Form',
      'verticalForm': 'Vertical Form',
      'modalForm': 'Pop-up Form',
      'multiForm': 'Multi-column Form'
    },
    'advancedForm': {
      'title': 'Advanced Form',
      'description': 'Advanced forms are used to edit related information in the list.'
    },
    'dynamicForm': {
      'title': 'Dynamic Form',
      'description': 'Dynamic forms can be created based on the metadata (JSON) of the business object model. The creation is quick, structured, and easy to maintain. For details about the differences between forms and normal forms, see the actual code.'
    }
  }
}
